import { IOption } from 'models';

export const isNotNullScore = ({
	satisfaction,
}: {
	satisfaction: number | null;
}) => satisfaction !== null;

export function toOption<T = string | number>({
	name,
	id,
}: {
	name: string;
	id: T;
}): IOption<T> {
	return {
		title: name,
		value: id,
	};
}

type ValueToOption<T = string | number> = (v: T) => IOption<T>;
export const stringToOption: ValueToOption<string> = (v: string) => ({
	title: v,
	value: v,
});
export const numberToOption: ValueToOption<number> = (v: number) => ({
	title: v.toString(),
	value: v,
});
